import { Receivable_Transaction_Type } from "gen/txn/models_pb"

import { useWebFilter } from "hooks/filters/useWebFilter"

export function useCreditTransactionTypeFilter() {
  const res = useWebFilter({
    key: "transactionType",
    label: "Transaction Type",
    values: values,
    keyExtractor: (v) => v.toString(),
    labelExtractor: (type) => labels[type] ?? "",
  })

  return {
    ...res,
    selected: res.selectedKeys.map((key) => Number(key)),
  }
}

const labels: Partial<Record<Receivable_Transaction_Type, string>> = {
  [Receivable_Transaction_Type.UNDEFINED]: "",
  [Receivable_Transaction_Type.BILL_PAYMENT]: "Bill Payment",
  [Receivable_Transaction_Type.RETURN]: "Return",
}

const values = [
  Receivable_Transaction_Type.BILL_PAYMENT,
  Receivable_Transaction_Type.RETURN,
].sort((a, b) => (labels[a] ?? "").localeCompare(labels[b] ?? ""))
